// extracted by mini-css-extract-plugin
export default {"tcSectionText":"TermsAndConditions_tcSectionText__1trpX"};